import React, { useEffect } from 'react';
import { Button, Modal, ModalHeader, ModalBody, Spinner, Alert, ModalFooter, } from 'reactstrap';

import { restartStatement } from '../../../../../slices/guide/reducer';
import { useSelector, useDispatch } from 'react-redux';
import { statementGuide } from '../../../../../slices/thunks';
import { createSelector } from 'reselect';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';

const ConfirmStatementModal = ({ guides, isOpen, handlerToggleModal, establishment, kilograms_declared }) => {
	const dispatch = useDispatch();
	const history = useNavigate();

	const selectorGuides = createSelector(
		state => state.Guides,
		guide => ({
			isStatementing: guide.isStatementing,
			isStatemented: guide.isStatemented,
			isStatementError: guide.isStatementError,
			requireCloseModal: guide.requireCloseModal
		})
	);

	const { isStatementing, isStatemented, isStatementError, requireCloseModal } = useSelector(selectorGuides);


	// validation
	const validation = useFormik({
		// enableReinitialize: use this flag when initial values needs to be changed
		enableReinitialize: false,
		initialValues: {
			guides: guides,
			establishment_id: '',
			kilograms_declared: ''
		},
		validationSchema: Yup.object({
		}),
		onSubmit: values => {
			const dataGuides = {
				guides: guides,
				establishment_id: establishment._id,
				kilograms_declared: kilograms_declared
			};
			console.log(dataGuides)
			dispatch(statementGuide(dataGuides));
		},
	});

	function handlerOkModal() {
		validation.submitForm();
	}

	useEffect(() => {
		if (isStatemented) {
			history('/residue/statement');
			dispatch(restartStatement());
		}
	}, [isStatemented])

	return (
		<div>
			<Modal
				isOpen={isOpen}
				toggle={() => handlerToggleModal()}
				size='sm'
				className='border-0'
				modalClassName='modal fade zoomIn'
				backdrop={'static'}
				centered={true}
			>
				<ModalHeader >Confirmar Declaración</ModalHeader>
				<ModalBody className='text-center p-3'>
					<lord-icon
						src='https://cdn.lordicon.com/tdrtiskw.json'
						trigger='loop'
						colors='primary:#f06548,secondary:#405189'
						style={{ width: '90px', height: '90px' }}
					></lord-icon>
					<div className='mt-2'>
						<h5 className='mb-3'>
							¡Atención! Estás a punto de confirmar la declaración de la suma de {kilograms_declared}kg de las guías seleccionadas del establecimiento:
						</h5>
						<h4>{establishment?.name}</h4>
						<p className='text-muted mb-4'>
							Si deseas realizar esta acción debes hacer click en
							confirmar.
						</p>
					</div>
				</ModalBody>
				<ModalFooter>
					<div className='hstack gap-2 justify-content-center'>
						<Button type='button' onClick={() => handlerToggleModal()} className='btn-danger btn-label'><i className="icon-x label-icon"></i> Cancelar</Button>
						<button
							className='btn btn-label btn-primary'
							onClick={() => handlerOkModal()}
							disabled={isStatementing}
						>
							{isStatementing ? (
								<i className='label-icon'><Spinner size='sm' /></i>
							) : <i className={`${Icons.check2} label-icon`}></i>}
							Confirmar
						</button>
					</div>
				</ModalFooter>
			</Modal>
		</div>
	);
};

export default ConfirmStatementModal;
